/* ============================================================
   Koleksiyon ızgarası (UI/UX denetimi, madde 18)
   - Sıralama seçimi: sayfadaki "Sırala" menüsü URL'deki sort_by'ı değiştirir.
   - "Daha fazla göster": sonraki sayfanın kartlarını section rendering ile
     çekip ızgaraya ekler (JS yoksa düz bağlantı olarak sonraki sayfaya gider).
   - Tükenenler sona: yeni kartlar eklendikten sonra tükenen kartlar yine en
     alta taşınır; sunucu her sayfayı zaten bu sırayla basıyor.

   Filtre formu ızgarayı innerHTML ile yeniden bastığı için dinleyiciler
   document üzerinde (delegation).
   ============================================================ */
(function () {
  'use strict';

  if (window.fosCollectionInit) return;
  window.fosCollectionInit = true;

  function soldOutToEnd(grid) {
    var soldOut = grid.querySelectorAll(':scope > li[data-sold-out]');
    Array.prototype.forEach.call(soldOut, function (li) {
      grid.appendChild(li);
    });
  }

  document.addEventListener('change', function (e) {
    var select = e.target.closest && e.target.closest('[data-fos-sort]');
    if (!select) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', select.value);
    url.searchParams.delete('page');
    window.location.assign(url.toString());
  });

  document.addEventListener('click', function (e) {
    var button = e.target.closest && e.target.closest('[data-fos-load-more]');
    if (!button) return;
    var grid = document.getElementById('main-collection-product-grid');
    if (!grid || !window.fetch || !window.DOMParser) return;
    e.preventDefault();
    if (button.classList.contains('is-loading')) return;

    var label = button.textContent;
    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');
    button.textContent = button.getAttribute('data-loading-label') || label;

    var url = new URL(button.href, window.location.origin);
    url.searchParams.set('section_id', button.getAttribute('data-section-id'));

    fetch(url.toString(), { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('load more failed: ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var items = doc.querySelectorAll('#main-collection-product-grid > li');
        Array.prototype.forEach.call(items, function (li) {
          grid.appendChild(document.importNode(li, true));
        });
        soldOutToEnd(grid);

        var wrap = button.closest('.fos-load-more');
        var nextButton = doc.querySelector('[data-fos-load-more]');
        var nextProgress = doc.querySelector('[data-fos-load-progress]');
        var progress = wrap && wrap.querySelector('[data-fos-load-progress]');
        if (progress && nextProgress) progress.textContent = nextProgress.textContent;

        if (nextButton) {
          button.href = nextButton.getAttribute('href');
          button.textContent = label;
          button.classList.remove('is-loading');
          button.removeAttribute('aria-busy');
        } else if (wrap) {
          wrap.parentNode.removeChild(wrap);
        }
      })
      .catch(function () {
        // Sessiz kalmasın: düz bağlantı gibi sonraki sayfaya git
        window.location.assign(button.href);
      });
  });
})();
